module.exports = __webpack_public_path__ + "media/images/WFC_Portrait_White-7438449b9ea55649eec18f2952abf32d.svg";